export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:9000';
// Cron microservice base URL — set REACT_APP_CRON_SERVICE_URL in .env
export const CRON_SERVICE_URL = process.env.REACT_APP_CRON_SERVICE_URL || 'http://localhost:9002';
// API key for protected cron endpoints (/trigger, /admin/system/*) — set REACT_APP_CRON_API_KEY in .env
export const CRON_API_KEY = process.env.REACT_APP_CRON_API_KEY || '';
